import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import {
  analyticsSpaAppointmentListSelector,
  fetchAnalyticSpaAppointmentList,
  totalSpaAppointmentsStatsSelector,
  fetchTotalSpaAppointmentsStats,
  mostBookedTreatmentsSelector,
  fetchMostBookedTreatments,
  spaActivityListSelector,
  fetchSpaServiceActivityList,
} from '../AnalyticsSlice';
import TablePaginationActions from '../../../shared/table-pagination/TablePaginationActions';
import moment from 'moment';
import CardWrapper from '../CardWrapper';
import {
  generateReservationExportData,
  generatePdfTable,
  generateTotalReservationExportData,
  generateChartPdfExportData,
} from '../../../utils/analyticUtils';
import './spa.scss';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
//temporarily disable
// import zc from "@dvsl/zoomcharts";
import ImageCardWrapper from '../ImageCardWrapper';
import ImageCard from '../ImageCard';
import PreviewPopup from '../PreviewPopup';
import { ASSET_URL, ENVIRONMENT } from '../../../env/Configurations';
import CustomLineChart from '../../../shared/charts/custom-line-chart/CustomLineChart';
import Wellness from '../../statistics/wellness/Wellness';
import WidgetWrapper from '../WidgetWrapper';
import { decryptLocalStorage } from '../../../utils/authUtils';
import { statisticsDataKeys } from '../Analytics';
import { notificationManager } from '../../../utils/NotificationUtils';
import { filteredHotelsSelector, selectedHotelSelector } from '../../property/propertySlice';
import { getSelectedHotelName } from '../../../utils/commonUtils';
import SummaryCardWrapper from '../SummaryCardWrapper';

const Spa = (props) => {
  const {
    startDate,
    endDate,
    hotelId,
    onsetPage,
    page,
    onsetRowsPerPage,
    rowsPerPage,
    spaId,
    showAllForReport = false,
    showLoader = () => {},
    setShowAllForReport = () => {},
  } = props;
  const dispatch = useDispatch();
  const [mostBookedTreatmentState, setMostBookedTreatmentState] = useState([]);
  const [isPreview, setIsPreview] = useState(false);
  const [rowsPerPages, setRowsPerPages] = useState(5);
  const [currPage, setCurrPage] = useState(0);
  const spaTableData = useSelector(analyticsSpaAppointmentListSelector);
  const totalSpaAppointmentData = useSelector(totalSpaAppointmentsStatsSelector);
  const spaActivityList = useSelector(spaActivityListSelector);
  const mostBookedTreatments = useSelector(mostBookedTreatmentsSelector);
  const selectedHotel = useSelector(selectedHotelSelector);
  const selectedHotelList = useSelector(filteredHotelsSelector);
  //temporarily disable
  // let TimeChart = zc.TimeChart;

  const [showNoData, setShowNoData] = useState(false);
  const parentElement = useRef(null);
  const [reservationChartData, setReservationChartData] = useState([]);
  const [isPdfExporting, setIsPdfExporting] = useState(false);
  const currency = totalSpaAppointmentData?.currencyCode;

  const updateDataAvailability = () => {
    parentElement.current = document?.getElementById('spa-analytics');

    if (
      (parentElement?.current?.childNodes?.length === 1 &&
        parentElement?.current?.childNodes[0]?.length <= 0) ||
      parentElement?.current?.childNodes?.length <= 0
    ) {
      setShowNoData(true);
    } else {
      setShowNoData(false);
    }
  };

  const currentHotelName = getSelectedHotelName(selectedHotelList, selectedHotel);

  useEffect(() => {
    setMostBookedTreatmentState(mostBookedTreatments);
    updateDataAvailability();
  }, [mostBookedTreatments]);

  useEffect(() => {
    onFetchSpaAppointmentData();
    onFetchTotalSpaAppointmentsData();
    onFetchMostBookedTreatmentsData();
    updateDataAvailability();
  }, [hotelId, startDate, endDate, spaId]);

  useEffect(() => {
    try {
      if (totalSpaAppointmentData && totalSpaAppointmentData?.dailyTotal?.values) {
        const sortedSpaData = totalSpaAppointmentData?.dailyTotal?.values
          ?.map(({ date, orderCount }) => ({
            Date: moment(new Date(date)).format(statisticsDataKeys.dateFormat),
            orderCount,
            [statisticsDataKeys.bookingCount]: orderCount,
          }))
          ?.sort((a, b) => new Date(a.Date) - new Date(b.Date));

        setReservationChartData(sortedSpaData);
      }
    } catch (error) {
      if (ENVIRONMENT === 'dev') {
        console.error(error.message);
      }
      if (error.message === 'Invalid category list') {
        notificationManager('danger', error.message);
      }
      return;
    }
    updateDataAvailability();
  }, [totalSpaAppointmentData, spaId]);

  const onFetchSpaAppointmentData = () => {
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      spaId,
    };
    dispatch(fetchAnalyticSpaAppointmentList(payload));
  };

  const onFetchMostBookedTreatmentsData = () => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      spaId,
      lang: language,
    };
    dispatch(fetchMostBookedTreatments(payload));
    dispatch(fetchSpaServiceActivityList(payload));
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event?.target?.value, 10));
    onsetPage(0);
  };

  const onFetchTotalSpaAppointmentsData = (option) => {
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
      spaId,
    };
    dispatch(fetchTotalSpaAppointmentsStats(payload));
  };
  const addWaterMark = (doc) => {
    var totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(150);
      doc.setTextColor('#E5E5E5');
      doc.saveGraphicsState();
      doc.setGState(new doc.GState({ opacity: 0.5 }));
      doc.text('Hudini', 50, doc.internal.pageSize.height - 50, {
        angle: 45,
      });
      doc.restoreGraphicsState();
    }
    return doc;
  };

  const addPageNumber = (doc) => {
    var totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(12);
      doc.setTextColor('#00000');
      doc.text(100, doc.internal.pageSize.height - 5, `${i} of ${totalPages}`);
    }

    return doc;
  };

  const generateSpaListPdf = () => {
    const tempData = spaTableData?.map((x) => {
      return {
        ...x,
        newDate: moment.unix(x?.date).format(statisticsDataKeys?.errorReportDateFormat),
      };
    });

    let body = generatePdfTable(tempData, ['newDate', 'spaName', 'bookingId', 'noOfGuests']);
    const header = ['Date', 'Spa', 'Booking Number', 'No Of Guests'];
    let doc = new jsPDF();

    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);
    // the "Top Heading"
    const titleText = 'SPA';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(24);
    //the Sub Heading
    const subTitleText = 'Appointment List';
    const subTitleWidth = (doc.getStringUnitWidth(subTitleText) * 24) / doc.internal.scaleFactor;
    const subTitleCenterX = (doc.internal.pageSize.width - subTitleWidth) / 2;
    doc.text(subTitleCenterX, 35, subTitleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc
      .text(70, 50, moment().format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc
      .text(70, 55, moment(startDate).format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc
      .text(70, 60, moment(endDate).format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    autoTable(doc, {
      headStyles: { fillColor: '#828282' },
      head: [header],
      body: body,
      startY: 70,
      theme: 'striped',
    });
    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-Spa-Appointment-list.pdf');
  };

  const generateTotalAppointmentsPdf = () => {
    let body = [];
    let header = [];
    if (totalSpaAppointmentData && totalSpaAppointmentData?.dailyTotal?.values) {
      let tempData = JSON.parse(totalSpaAppointmentData?.dailyTotal?.values);
      body = generateChartPdfExportData(tempData);
      const tempRest = totalSpaAppointmentData?.dailyTotal?.spas;
      header = ['Date', ...tempRest];
    }
    let doc = new jsPDF(
      header.length > 10 ? { orientation: 'landscape' } : { orientation: 'portrait' },
    );
    doc.setTextColor('#6B6B6B');
    doc.setFontSize(32);
    // the "Top Heading"
    const titleText = 'SPA';
    const titleWidth = (doc.getStringUnitWidth(titleText) * 32) / doc.internal.scaleFactor;
    const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(centerX, 20, titleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(24);
    //the sub heading
    const subTitleText = 'Appointments';
    const subTitleWidth = (doc.getStringUnitWidth(subTitleText) * 24) / doc.internal.scaleFactor;
    const subTitleCenterX = (doc.internal.pageSize.width - subTitleWidth) / 2;
    doc.text(subTitleCenterX, 35, subTitleText).setFont(undefined, 'bold');
    doc.setTextColor('#00000');
    doc.setFontSize(12);
    doc.text(20, 50, 'Generated Date:').setFont(undefined, 'bold');
    doc
      .text(70, 50, moment().format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 55, 'From Date:').setFont(undefined, 'bold');
    doc
      .text(70, 55, moment(startDate).format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 60, 'To Date:').setFont(undefined, 'bold');
    doc
      .text(70, 60, moment(endDate).format(statisticsDataKeys?.errorReportDateFormat))
      .setFont(undefined, 'bold');
    doc.text(20, 70, 'Total Spa Appointments:').setFont(undefined, 'normal');
    doc.text(70, 70, totalSpaAppointmentData?.total.toString()).setFont(undefined, 'normal');
    let start = 0,
      end = 10,
      startY = 80;
    while (start < header.length) {
      doc.autoTable({
        headStyles: { fillColor: '#828282' },
        head: [start === 0 ? header.slice(start, end) : ['Date', ...header.slice(start, end)]],
        body:
          body.length === 0
            ? []
            : start === 0
            ? body.slice(start, end)
            : [body[0], ...body.slice(start, end)],
        startY: startY,
        theme: 'striped',
      });
      startY += body.length == 0 ? 50 : body.length * 20;
      start = end;
      end += 10;
    }
    doc = addWaterMark(doc);
    doc = addPageNumber(doc);
    doc.save('Elevate-Total-Spa-Appointments.pdf');
  };

  const handleClose = () => {
    setIsPreview(false);
  };

  const spaMatrix = [
    {
      title: 'Booking count',
      subTitle: 'Total Booking',
      totalCount: (totalSpaAppointmentData && totalSpaAppointmentData?.total) || 0,
      uniqueCount: '',
    },
  ];

  const TableData = () => {
    return (
      <TableContainer>
        <Table className='list-table ' aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>Rank</TableCell>
              <TableCell>Treatment Name</TableCell>
              <TableCell>Booked</TableCell>
              <TableCell>Total Revenue</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPages > 0
              ? spaActivityList?.slice(
                  currPage * rowsPerPages,
                  currPage * rowsPerPages + rowsPerPages,
                )
              : spaActivityList
            )?.map((user, i) => (
              <TableRow key={i} className='border-white pointer'>
                <TableCell>{user?.rank}</TableCell>
                <TableCell>{user?.name}</TableCell>
                <TableCell>{user?.bookings}</TableCell>
                <TableCell>{user?.revenue}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow className='paginator'>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                count={spaActivityList?.length}
                rowsPerPage={rowsPerPages}
                page={currPage}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'Items per page',
                  },
                  native: true,
                }}
                onPageChange={(event, newPage) => {
                  setCurrPage(newPage);
                }}
                onRowsPerPageChange={(e) => {
                  setRowsPerPages(parseInt(e?.target?.value, 10));
                  setCurrPage(0);
                }}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    );
  };

  return (
    <>
      {showNoData ? (
        <span className='py-2'>
          Unable to generate reports due to third-party integration limitations.
        </span>
      ) : null}
      <div id='Appointments' className='d-flex flex-column gap-3'>
        <CardWrapper
          title='Appointments'
          hotelName={currentHotelName}
          startDate={startDate}
          endDate={endDate}
          showExportButton={true}
          onClickRefreshBtn={onFetchTotalSpaAppointmentsData}
          exportData={generateTotalAppointmentsPdf}
          excelData={generateTotalReservationExportData(
            totalSpaAppointmentData,
            startDate,
            endDate,
            'spa',
          )}
          showLoader={showLoader}
          showAllForReport={showAllForReport}
          setShowAllForReport={setShowAllForReport}
        >
          <div className='d-flex flex-wrap p-1 col-12'>
            <div className='progress-widget-container col-4 col-md-4 col-lg-3'>
              {spaMatrix?.map((summary, index) => (
                <SummaryCardWrapper
                  key={index}
                  title={summary?.title}
                  total={summary?.totalCount}
                  subTitle={summary?.subTitle}
                  className='col-12'
                />
              ))}
            </div>
          </div>
          {reservationChartData?.length > 0 && (
            <WidgetWrapper
              title={'Total Appointments'}
              width='95%'
              isCustom={true}
              className='px-3'
            >
              <CustomLineChart
                xAxis={statisticsDataKeys?.date}
                yAxis={statisticsDataKeys?.orderCount}
                data={reservationChartData?.map((order, index) => {
                  return {
                    [statisticsDataKeys.date]: order?.Date,
                    [statisticsDataKeys.orderCount]: order?.orderCount,
                    [statisticsDataKeys.bookingCount]: order?.[statisticsDataKeys?.bookingCount],
                  };
                })}
                sliderX={true}
                tooltipItems={[statisticsDataKeys?.bookingCount]}
              />
            </WidgetWrapper>
          )}
        </CardWrapper>

        {spaId &&
          spaId !== 'allSpa' &&
          mostBookedTreatmentState &&
          mostBookedTreatmentState?.mostBookedTreatments?.length > 0 && (
            <ImageCardWrapper
              title={'Most Booked Treatments'}
              onClickExpand={() => setIsPreview(true)}
              onClickRefreshBtn={onFetchMostBookedTreatmentsData}
            >
              <div className='p-2 d-flex justify-content-around'>
                {mostBookedTreatmentState?.mostBookedTreatments?.map((img, i) => (
                  <ImageCard
                    title={img?.name}
                    count={i + 1}
                    subTitle1={`Bookings: ${img?.bookings}`}
                    subTitle2={`Revenue: ${img?.revenue}`}
                    url={
                      (img?.images && ASSET_URL + img.images[0]?.master) ||
                      './assets/img/analytics/spa-no-image.png'
                    }
                  />
                ))}
              </div>
              <div className='analytic-breaker-light m-0' />
              <div className='mx-2 d-flex'>
                <div className='total-booking me-4 ms-1'>
                  <span>{mostBookedTreatmentState?.totalBookings}</span>
                  <span className='total-title ms-1'>Total Bookings</span>
                </div>
                <div className='total-booking2 me-4 ms-1'>
                  <span>{mostBookedTreatmentState?.totalRevenue}</span>{' '}
                  <span className='total-title'>Total Revenue</span>
                </div>
              </div>
            </ImageCardWrapper>
          )}
        {spaTableData?.length > 0 && (
          <CardWrapper
            title='Appointment List'
            isInformation={'List of appointments in the given time frame'}
            start={startDate}
            end={endDate}
            onClickRefreshBtn={onFetchSpaAppointmentData}
            exportData={generateSpaListPdf}
            excelData={generateReservationExportData(spaTableData, startDate, endDate, 'spa')}
            showAllForReport={showAllForReport}
            setShowAllForReport={setShowAllForReport}
          >
            <div className='row mx-2 d-flex mt-4'>
              <TableContainer>
                <Table className='list-table ' aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Spa</TableCell>
                      <TableCell>Booking Number</TableCell>
                      <TableCell>No of Guest</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? spaTableData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : spaTableData
                    )?.map((user, i) => (
                      <TableRow key={i} className='border-white pointer'>
                        <TableCell>{moment.unix(user?.date).format('DD MMM, YYYY')}</TableCell>
                        <TableCell>{user?.spaName}</TableCell>
                        <TableCell>{user?.bookingId || '---'}</TableCell>
                        <TableCell>{user?.noOfGuests}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  {!showAllForReport && (
                    <TableFooter>
                      <TableRow className='paginator'>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                          count={spaTableData?.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          SelectProps={{
                            inputProps: {
                              'aria-label': 'Items per page',
                            },
                            native: true,
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  )}
                </Table>
              </TableContainer>
            </div>
          </CardWrapper>
        )}

        <Wellness
          key='Wellness'
          allStatisticsData={totalSpaAppointmentData?.spaStatistics}
          selectedSpa={{ value: [spaId] }}
          currency={currency}
          showAllForReport={showAllForReport}
        />

        {mostBookedTreatmentState &&
          mostBookedTreatmentState?.mostBookedTreatments?.length > 0 &&
          isPreview && (
            <PreviewPopup
              viewPreviewStatus={isPreview}
              handleClose={handleClose}
              title='Most Booked Treatments'
              subTitle1='Top 5 Appointments'
              subTitle2='Treatment Activity'
              topAppointment={mostBookedTreatmentState?.mostBookedTreatments?.map((x) => {
                return {
                  ...x,
                  sub1: `Bookings: ${x?.bookings}`,
                  sub2: `Revenue: ${x?.revenue}`,
                  img:
                    (x?.images && ASSET_URL + x?.images[0]?.master) ||
                    './assets/img/analytics/spa-no-image.png',
                };
              })}
              count={mostBookedTreatmentState?.totalBookings}
              revenue={mostBookedTreatmentState?.totalRevenue}
            >
              <TableData />
            </PreviewPopup>
          )}
      </div>
    </>
  );
};

export default Spa;
